import React, { useState, useEffect } from "react";
import { Menu, Button, HStack, Text, Box } from "native-base";
import { useTranslation } from "react-i18next";
import { BsChevronDown } from "react-icons/bs";
import { AiOutlineCheck } from "react-icons/ai";
import colors from "theme/colors";

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language || "id");

  const changeLanguage = async (itemValue) => {
    setLanguage(itemValue);
    await i18n.changeLanguage(itemValue);
    localStorage.setItem("selectedLanguage", itemValue);
  };

  // Ensure local state syncs with i18n on mount/change
  useEffect(() => {
    if (i18n.language !== language) {
      setLanguage(i18n.language);
    }
  }, [i18n.language]);

  const languages = [
    { label: "Bahasa", value: "id", icon: "🇮🇩" },
    { label: "English", value: "en", icon: "🌐" },
  ];

  const renderTrigger = (triggerProps) => {
    const selectedLabel = languages.find((l) => l.value === language)?.label || "Bahasa";
    const selectedIcon = languages.find((l) => l.value === language)?.icon || "🇮🇩";

    return (
      <Button variant="ghost" {...triggerProps} p={0}>
        <HStack
          alignItems="center"
          bg="white"
          borderRadius="md"
          borderWidth={1}
          borderColor={colors.disabled.smoke} // Updated border color
          px={3}
          py={1}
          height={{ base: "35px", md: "40px" }}
          width={{ base: "110px", md: "130px" }}
          justifyContent="space-between"
        >
          <HStack alignItems="center" space={2}>
            <Text style={{ lineHeight: "20px" }}>{selectedIcon}</Text>
            <Text style={{ lineHeight: "20px" }}>{selectedLabel}</Text>
          </HStack>
          <BsChevronDown size="17px" color={colors.neutral.charcoal} />
        </HStack>
      </Button>
    );
  };

  // Helper to center text vertically if needed
  const centeredText = (icon, label) => (
    <HStack alignItems="center" space={3}>
      <Text style={{ lineHeight: "20px" }}>{icon}</Text>
      <Text style={{ lineHeight: "20px" }}>{label}</Text>
    </HStack>
  );

  return (
    <Box mr={4} mb={5}>
      {" "}
      {/* Increased margin to move it left relative to the name */}
      <Menu
        trigger={renderTrigger}
        shouldFlip
        placement="bottom right"
        w="160" // Increased width for better spacing in dropdown
        bg={colors.neutral.cotton}
      >
        {languages.map((item) => (
          <Menu.Item
            key={item.value}
            onPress={() => changeLanguage(item.value)}
            py={3}
            px={2} // Reduced padding to fix "spacing on the left of flag"
          >
            <HStack width="100%" alignItems="center" justifyContent="space-between">
              {centeredText(item.icon, item.label)}
              {language === item.value && <AiOutlineCheck size="16px" color={colors.secondary.orchid} />}
            </HStack>
          </Menu.Item>
        ))}
      </Menu>
    </Box>
  );
};

export default LanguageSelector;
